/* eslint-disable camelcase */
import { match } from '@nike/rcf-fp';
import { Default as _ } from '@nike/rcf-fp/src/match/match';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

const FACTURA = 'FACTURA';
const FACT_SIM = 'FACTURA SIMPLIFICADA';
const SpainSpecificHeader = ({ contactDetails, country }) => {
  const {
    RL_InvoiceNumber, RL_OrigInvoiceNo,
  } = useSelector((state) => state);
  const getInvoicePrefix = (invoiceNum) => {
    if (!invoiceNum) return '';
    const prefix3 = invoiceNum.substring(0, 3);
    if (['ORV', 'OTV'].includes(prefix3)) return prefix3;
    return invoiceNum.substring(0, 2);
  };

  const documentNumber = (type) => match(type)(
    ['RV', FACTURA],
    ['ORV', FACTURA],
    ['TV', FACT_SIM],
    ['OTV', FACT_SIM],
    [_, '']
  );

  const invoiceNumber = contactDetails?.[0]?.OriginalTaxInvoice?.Number || contactDetails[0]?.TaxInvoice?.Number;
  const custCountry = (contactDetails?.[0]?.Addresses && contactDetails?.[0]?.Addresses[0]?.Country) || country;
  const postal = contactDetails?.[0]?.Addresses && contactDetails?.[0]?.Addresses[0]?.PostalCode;
  const city = contactDetails?.[0]?.Addresses && contactDetails?.[0]?.Addresses[0]?.City;
  const line = contactDetails?.[0]?.Addresses && contactDetails?.[0]?.Addresses[0].AddressLines[0]?.Line;
  const id = contactDetails?.[0] && contactDetails?.[0]?.ID;
  const namePart = contactDetails?.[0]?.Name?.Names?.[0]?.NamePart;
  const cityName = city?.split(',').slice(-1)[0];

  return (
    <>
      <p>NIKE RETAIL SUCURSAL EN ESPAÑA</p>
      <p>{documentNumber(getInvoicePrefix(invoiceNumber))}</p>
      <br />
      {contactDetails?.[0]?.TaxInvoice?.Number && (
        <p>
          {RL_InvoiceNumber}: {contactDetails?.[0]?.TaxInvoice?.Number}
        </p>
      )}
      {contactDetails?.[0]?.OriginalTaxInvoice?.Number && (
        <p>
          {RL_OrigInvoiceNo}: {contactDetails?.[0]?.OriginalTaxInvoice?.Number}
        </p>
      )}
      <br />
      {documentNumber(getInvoicePrefix(invoiceNumber)) === FACTURA && (
        <>
          {namePart && (
            <article className="justify-between align-left display-block">
              <p className="align-left">Nombre : {namePart}</p>
            </article>
          )}
          {id && (
            <article className="justify-between align-left display-block">
              <p className="align-left">N.I.F : {id}</p>
            </article>
          )}
          {line && (
            <article className="justify-between align-left display-block">
              <p className="align-left">Direccion : {line}</p>
            </article>
          )}
          {cityName && (
            <article className="justify-between align-left display-block">
              <p className="align-left">Ciudad : {cityName}</p>
            </article>
          )}
          {postal && (
            <article className="justify-between align-left display-block">
              <p className="align-left">C.Postal : {postal}</p>
            </article>
          )}
          {custCountry && (
            <article className="justify-between align-left display-block">
              <p className="align-left">Pais : {custCountry}</p>
            </article>
          )}
        </>
      )}
      <br />
    </>
  );
};

SpainSpecificHeader.defaultProps = {
  contactDetails: [],
  country: '',
};

SpainSpecificHeader.propTypes = {
  contactDetails: PropTypes.arrayOf(PropTypes.shape()),
  country: PropTypes.string,
};

export default SpainSpecificHeader;
